import { render, staticRenderFns } from "./CooperationLinks.vue?vue&type=template&id=7213fcd6&"
import script from "./CooperationLinks.vue?vue&type=script&lang=js&"
export * from "./CooperationLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports